import React, { useMemo } from 'react';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import colors from '../../theme/colors';

function socColor(val) {
  if (val >= 60) return colors.socHigh;
  if (val >= 30) return colors.socMid;
  return colors.socLow;
}

export default function GaugeChart({ value, label, max = 100, unit = '%', height = 160 }) {
  const options = useMemo(() => ({
    chart: {
      type: 'solidgauge',
      height,
      backgroundColor: 'transparent',
      margin: [0, 0, 0, 0],
    },
    title: null,
    pane: {
      startAngle: -130,
      endAngle: 130,
      background: [{
        backgroundColor: colors.surface,
        innerRadius: '75%',
        outerRadius: '100%',
        shape: 'arc',
        borderWidth: 0,
      }],
      center: ['50%', '60%'],
      size: '100%',
    },
    yAxis: {
      min: 0,
      max,
      lineWidth: 0,
      tickWidth: 0,
      minorTickLength: 0,
      labels: { enabled: false },
      stops: [
        [0.3, colors.socLow],
        [0.6, colors.socMid],
        [1, colors.socHigh],
      ],
    },
    series: [{
      name: label || 'SoC',
      data: [value != null ? Math.round(value * 10) / 10 : 0],
      innerRadius: '75%',
      radius: '100%',
      dataLabels: {
        format: `<span style="font-size:18px;font-weight:700;color:${value != null ? socColor(value) : colors.textDim}">{y}</span><span style="font-size:11px;color:${colors.textMuted}">${unit}</span>`,
        borderWidth: 0,
        y: -15,
      },
    }],
    tooltip: { enabled: false },
    plotOptions: {
      solidgauge: {
        animation: false,
      },
    },
  }), [value, label, max, unit, height]);

  return <HighchartsReact highcharts={Highcharts} options={options} />;
}
